<div
  bsModal
  #newContactModal="bs-modal"
  class="modal fade"
  id="newContactModal"
  tabindex="-1"
  aria-labelledby="newContactModalLabel"
  aria-hidden="true"
>
<div class="modal-dialog modal-dialog-centered" style="min-width: 60%">
  <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="newContactModalLabel">Agregar Codeudor</h5>
      </div>
      <div class="modal-body">
        <mat-stepper [linear]="false" #stepper>
          <mat-step [stepControl]="firstFormGroup">
            <ng-template matStepLabel>Información general</ng-template>
            <form
              [formGroup]="firstFormGroup"
              autocomplete="off"
              class="needs-validation createContact-form"
              id="createContact-form"
              novalidate
            >
              <div class="row">
                <div class="col-lg-12">
                  <div class="mb-3">
                    <label for="username-input" class="form-label"
                      >Nombres</label
                    >
                    <input
                      type="text"
                      id="username-input"
                      class="form-control"
                      placeholder="Ingrese nombres"
                      formControlName="name"
                      required
                    />
                    <div
                      *ngIf="this.firstFormGroup.controls['name'].invalid"
                      style="display: block"
                      class="invalid-feedback"
                    >
                      Por favor ingrese los nombres.
                    </div>
                  </div>

                  <div class="mb-3">
                    <label for="username-input" class="form-label"
                      >Apellidos</label
                    >
                    <input
                      type="text"
                      id="username-input"
                      class="form-control"
                      placeholder="Ingrese apellidos"
                      formControlName="lastName"
                      required
                    />
                    <div
                      *ngIf="this.firstFormGroup.controls['lastName'].invalid"
                      style="display: block"
                      class="invalid-feedback"
                    >
                      Por favor ingrese los apellidos.
                    </div>
                  </div>

                  <div class="mb-3 row">
                    <label for="rol-input" class="form-label"
                      >Tipo de documento</label
                    >
                    <div class="col-md-10">
                      <select
                        class="form-select"
                        placeholder="Seleccione un rol"
                        formControlName="documentType"
                        required
                      >
                        <option>Seleccione</option>
                        <option value="CC">Cédula de ciudadanía</option>
                        <option value="CE">Cédula de extranjeria</option>
                        <option value="NIT">NIT</option>
                        <option value="PAS">Pasaporte</option>
                      </select>
                    </div>
                    <div
                      *ngIf="
                        this.firstFormGroup.controls['documentType'].invalid
                      "
                      style="display: block"
                      class="invalid-feedback"
                    >
                      Porfavor ingrese un tipo de documento.
                    </div>
                  </div>

                  <div class="mb-3">
                    <label for="documentNumber-input" class="form-label"
                      >Número documento</label
                    >
                    <input
                      (input)="onDocumentNumberInput($event, 'documentNumber')"
                      type="text"
                      id="documentNumber-input"
                      class="form-control"
                      placeholder="Ingrese documento"
                      formControlName="documentNumber"
                      required
                    />
                    <div
                      *ngIf="
                        this.firstFormGroup.controls['documentNumber'].invalid
                      "
                      style="display: block"
                      class="invalid-feedback"
                    >
                      Porfavor ingrese un número valido.
                    </div>
                  </div>
                  <div class="mb-3">
                    <label for="username-input" class="form-label"
                      >Fecha de nacimiento</label
                    >
                    <input
                      type="date"
                      id="username-input"
                      class="form-control"
                      placeholder="Ingrese la fecha"
                      formControlName="birthDate"
                      required
                    />
                    <div
                      *ngIf="this.firstFormGroup.controls['birthDate'].invalid"
                      style="display: block"
                      class="invalid-feedback"
                    >
                      Por favor ingrese la fecha.
                    </div>
                  </div>

                  <div class="mb-3">
                    <label for="city-input" class="form-label"
                      >Ciudad de residencia</label
                    >
                    <input
                      type="text"
                      id="city-input"
                      class="form-control"
                      placeholder="Ingrese ciudad"
                      formControlName="city"
                      required
                    />
                    <div
                      *ngIf="this.firstFormGroup.controls['city'].invalid"
                      style="display: block"
                      class="invalid-feedback"
                    >
                      Porfavor ingrese una ciudad valida.
                    </div>
                  </div>

                  <div class="mb-3">
                    <label for="address-input" class="form-label"
                      >Dirección</label
                    >
                    <input
                      type="text"
                      id="address-input"
                      class="form-control"
                      placeholder="Ingrese dirección"
                      formControlName="address"
                      required
                    />
                    <div
                      *ngIf="this.firstFormGroup.controls['address'].invalid"
                      style="display: block"
                      class="invalid-feedback"
                    >
                      Porfavor ingrese una dirección valida.
                    </div>
                  </div>

                  <div class="mb-3">
                    <label for="phone-input" class="form-label">Teléfono</label>
                    <input
                      (input)="onDocumentNumberInput($event, 'phone')"
                      type="text"
                      id="phone-input"
                      class="form-control"
                      placeholder="Ingrese Teléfono"
                      formControlName="phone"
                      required
                    />
                    <div
                      *ngIf="this.firstFormGroup.controls['phone'].invalid"
                      style="display: block"
                      class="invalid-feedback"
                    >
                      Porfavor ingrese un Teléfono valido.
                    </div>
                  </div>

                  <div class="mb-3">
                    <label for="cellPhone-input" class="form-label"
                      >Número de celular</label
                    >
                    <input
                      (input)="onDocumentNumberInput($event, 'cellPhone')"
                      type="text"
                      id="cellPhone-input"
                      class="form-control"
                      placeholder="Ingrese celular"
                      formControlName="cellPhone"
                      required
                    />
                    <div
                      *ngIf="this.firstFormGroup.controls['cellPhone'].invalid"
                      style="display: block"
                      class="invalid-feedback"
                    >
                      Porfavor ingrese un Teléfono valido.
                    </div>
                  </div>

                  <div class="mb-3">
                    <label for="email-input" class="form-label"
                      >Correo electrónico</label
                    >
                    <input
                      type="email"
                      id="email-input"
                      class="form-control"
                      placeholder="Ingrese email"
                      formControlName="email"
                      required
                    />
                    <div
                      *ngIf="this.firstFormGroup.controls['email'].invalid"
                      style="display: block"
                      class="invalid-feedback"
                    >
                      Ingrese una email valido.
                    </div>
                  </div>

                  <div class="mb-3 row">
                    <label for="gender-input" class="form-label">Genero</label>
                    <div class="col-md-10">
                      <select
                        class="form-select"
                        placeholder="Seleccione un genero"
                        formControlName="gender"
                        required
                      >
                        <option>Seleccione</option>
                        <option value="0">Masculino</option>
                        <option value="1">Femenino</option>
                      </select>
                    </div>
                    <div
                      *ngIf="this.firstFormGroup.controls['gender'].invalid"
                      style="display: block"
                      class="invalid-feedback"
                    >
                      Porfavor ingrese genero.
                    </div>
                  </div>

                  <div class="mb-3">
                    <label for="stratum-input" class="form-label"
                      >Estrato</label
                    >
                    <input
                      (input)="onDocumentNumberInput($event, 'stratum')"
                      type="text"
                      id="stratum-input"
                      class="form-control"
                      placeholder="Ingrese estrato"
                      formControlName="stratum"
                      required
                    />
                    <div
                      *ngIf="this.firstFormGroup.controls['stratum'].invalid"
                      style="display: block"
                      class="invalid-feedback"
                    >
                      Porfavor ingrese un estrato valido.
                    </div>
                  </div>

                  <div class="mb-3">
                    <label for="cityBorn-input" class="form-label"
                      >Ciudad de nacimiento</label
                    >
                    <input
                      type="text"
                      id="cityBorn-input"
                      class="form-control"
                      placeholder="Ingrese ciudad de nacimiento"
                      formControlName="cityBorn"
                      required
                    />
                    <div
                      *ngIf="this.firstFormGroup.controls['cityBorn'].invalid"
                      style="display: block"
                      class="invalid-feedback"
                    >
                      Por favor ingrese la ciudad de nacimiento.
                    </div>
                  </div>

                  <div class="mb-3 row">
                    <label for="maritalStatus-input" class="form-label"
                      >Estado civil</label
                    >
                    <div class="col-md-10">
                      <select
                        class="form-select"
                        placeholder="Seleccione un estado civil"
                        formControlName="maritalStatus"
                        required
                      >
                        <option>Seleccione</option>
                        <option value="0">Soltero</option>
                        <option value="1">Casado</option>
                        <option value="2">Viudo</option>
                        <option value="3">Union libre</option>
                        <option value="4">Divorciado</option>
                      </select>
                    </div>
                    <div
                      *ngIf="
                        this.firstFormGroup.controls['maritalStatus'].invalid
                      "
                      style="display: block"
                      class="invalid-feedback"
                    >
                      Porfavor ingrese un estado civil.
                    </div>
                  </div>
                  <div class="mb-3 row">
                    <label for="houseType-input" class="form-label"
                      >Tipo de vivienda</label
                    >
                    <div class="col-md-10">
                      <select
                        class="form-select"
                        placeholder="Seleccione un tipo de vivienda"
                        formControlName="houseType"
                        required
                      >
                        <option>Seleccione</option>
                        <option value="0">Propia</option>
                        <option value="1">Arrendada</option>
                        <option value="2">Familiar</option>
                      </select>
                    </div>
                    <div
                      *ngIf="this.firstFormGroup.controls['houseType'].invalid"
                      style="display: block"
                      class="invalid-feedback"
                    >
                      Porfavor ingrese un tipo de vivienda.
                    </div>
                  </div>

                  <div class="mb-3">
                    <label for="housingTime-input" class="form-label"
                      >Tiempo en vivienda (Años)</label
                    >
                    <input
                      (input)="onDocumentNumberInput($event, 'housingTime')"
                      type="text"
                      id="stratum-input"
                      class="form-control"
                      placeholder="Ingrese Tiempo en vivienda"
                      formControlName="housingTime"
                      required
                    />
                    <div
                      *ngIf="
                        this.firstFormGroup.controls['housingTime'].invalid
                      "
                      style="display: block"
                      class="invalid-feedback"
                    >
                      Por favor ingrese un tiempo en vivienda.
                    </div>
                  </div>

                  <div class="mb-3 row">
                    <label for="academicLevel-input" class="form-label"
                      >Nivel academico</label
                    >
                    <div class="col-md-10">
                      <select
                        class="form-select"
                        placeholder="Seleccione un nivel academico"
                        formControlName="academicLevel"
                        required
                      >
                        <option>Seleccione</option>
                        <option value="0">Ninguno</option>
                        <option value="1">Bachiller</option>
                        <option value="2">Pregrado</option>
                        <option value="3">Posgrado</option>
                      </select>
                    </div>
                    <div
                      *ngIf="
                        this.firstFormGroup.controls['academicLevel'].invalid
                      "
                      style="display: block"
                      class="invalid-feedback"
                    >
                      Porfavor ingrese un nivel academico.
                    </div>
                  </div>
                </div>
                <div class="col-lg-12">
                  <div class="text-end"></div>
                </div>
              </div>
            </form>
            <div>
              <button class="btn btn-success" mat-button matStepperNext>
                Siguiente
              </button>
            </div>
          </mat-step>
          <mat-step [stepControl]="secondFormGroup">
            <ng-template matStepLabel>Empleo</ng-template>
            <form
              [formGroup]="secondFormGroup"
              autocomplete="off"
              class="needs-validation secondFormGroup-form"
              id="secondFormGroup-form"
              novalidate
            >
              <div class="row">
                <div class="mb-3 row">
                  <label for="employeeType-input" class="form-label"
                    >Tipo de empleado</label
                  >
                  <div class="col-md-10">
                    <select
                      class="form-select"
                      placeholder="Seleccione un tipo de empleado"
                      formControlName="employeeType"
                      required
                    >
                      <option>Seleccione</option>
                      <option value="0">Empleado</option>
                      <option value="1">Independiente</option>
                      <option value="2">Pensionado</option>
                    </select>
                  </div>
                </div>
                <div
                  class="mb-3"
                  *ngIf="secondFormGroup.get('employeeType').value === '0'"
                >
                  <label for="enterpriseName-input" class="form-label"
                    >Nombre empresa</label
                  >
                  <input
                    type="text"
                    id="enterpriseName-input"
                    class="form-control"
                    placeholder="Ingrese nombre empresa"
                    formControlName="enterpriseName"
                    required
                  />
                  <div
                    *ngIf="
                      this.secondFormGroup.controls['enterpriseName'].invalid
                    "
                    style="display: block"
                    class="invalid-feedback"
                  >
                    Por favor ingrese el nombre de la empresa.
                  </div>
                </div>
                <div
                  class="mb-3 row"
                  *ngIf="secondFormGroup.get('employeeType').value === '0'"
                >
                  <label for="contractType-input" class="form-label"
                    >Tipo de contrato</label
                  >
                  <div class="col-md-10">
                    <select
                      class="form-select"
                      placeholder="Seleccione un tipo de contrato"
                      formControlName="contractType"
                      required
                    >
                      <option>Seleccione</option>
                      <option value="0">Termino fijo</option>
                      <option value="1">Indefinido</option>
                      <option value="2">Prestación de servicios</option>
                    </select>
                  </div>
                </div>
              </div>
            </form>
            <div>
              <button
                class="btn btn-outline-secondary me-1"
                mat-button
                matStepperPrevious
              >
                Anterior
              </button>
              <button class="btn btn-success" mat-button matStepperNext>
                Siguiente
              </button>
            </div>
          </mat-step>
          <mat-step [stepControl]="ThirdFormGroup">
            <ng-template matStepLabel>Ingresos</ng-template>
            <form
              [formGroup]="ThirdFormGroup"
              autocomplete="off"
              class="needs-validation ThirdFormGroup-form"
              id="ThirdFormGroup-form"
              novalidate
            >
              <div class="row">
                <div class="mb-3">
                  <label for="incoming-input" class="form-label"
                    >Ingreso fijo</label
                  >
                  <input
                    (input)="onDocumentNumberInputFrom3($event, 'incoming')"
                    type="text"
                    id="incoming-input"
                    class="form-control"
                    placeholder="Ingrese ingreso fijo"
                    formControlName="incoming"
                    required
                  />
                  <div
                    *ngIf="this.ThirdFormGroup.controls['incoming'].invalid"
                    style="display: block"
                    class="invalid-feedback"
                  >
                    Porfavor ingrese ingresos fijos.
                  </div>
                </div>
                <div class="mb-3">
                  <label for="anotherIncoming-input" class="form-label"
                    >Otros ingresos</label
                  >
                  <input
                    (input)="
                      onDocumentNumberInputFrom3($event, 'anotherIncoming')
                    "
                    type="text"
                    id="anotherIncoming-input"
                    class="form-control"
                    placeholder="Otros ingresos"
                    formControlName="anotherIncoming"
                    required
                  />
                  <div
                    *ngIf="
                      this.ThirdFormGroup.controls['anotherIncoming'].invalid
                    "
                    style="display: block"
                    class="invalid-feedback"
                  >
                    Por favor ingrese un otros ingresos.
                  </div>
                </div>

                <div class="mb-3">
                  <label for="totalIncoming-input" class="form-label"
                    >Total ingresos</label
                  >
                  <input
                    id="totalIncoming-input"
                    class="form-control"
                    formControlName="totalIncoming"
                    disabled
                  />
                </div>
                <div class="mb-3">
                  <label for="personalExpenses-input" class="form-label"
                    >Gastos personales</label
                  >
                  <input
                    (input)="
                      onDocumentNumberInputFrom3($event, 'personalExpenses')
                    "
                    type="text"
                    id="personalExpenses-input"
                    class="form-control"
                    placeholder="Ingrese Gastos personales"
                    formControlName="personalExpenses"
                    required
                  />
                  <div
                    *ngIf="
                      this.ThirdFormGroup.controls['personalExpenses'].invalid
                    "
                    style="display: block"
                    class="invalid-feedback"
                  >
                    Porfavor ingrese gastos personales.
                  </div>
                </div>
                <div class="mb-3">
                  <label for="creditExpenses-input" class="form-label"
                    >Gastos por creditos</label
                  >
                  <input
                    (input)="
                      onDocumentNumberInputFrom3($event, 'creditExpenses')
                    "
                    type="text"
                    id="creditExpenses-input"
                    class="form-control"
                    placeholder="Ingrese Gastos por creditos"
                    formControlName="creditExpenses"
                    required
                  />
                  <div
                    *ngIf="
                      this.ThirdFormGroup.controls['creditExpenses'].invalid
                    "
                    style="display: block"
                    class="invalid-feedback"
                  >
                    Porfavor ingrese Gastos por creditos.
                  </div>
                </div>
                <div class="mb-3">
                  <label for="totalAssets-input" class="form-label"
                    >Total Activos</label
                  >
                  <input
                    (input)="onDocumentNumberInputFrom3($event, 'totalAssets')"
                    type="text"
                    id="totalAssets-input"
                    class="form-control"
                    placeholder="Total Activos"
                    formControlName="totalAssets"
                    required
                  />
                  <div
                    *ngIf="this.ThirdFormGroup.controls['totalAssets'].invalid"
                    style="display: block"
                    class="invalid-feedback"
                  >
                    Porfavor ingrese un Total Activos.
                  </div>
                </div>
                <div class="mb-3">
                  <label for="totalLiabilities-input" class="form-label"
                    >Total Pasivos</label
                  >
                  <input
                    (input)="
                      onDocumentNumberInputFrom3($event, 'totalLiabilities')
                    "
                    type="text"
                    id="totalLiabilities-input"
                    class="form-control"
                    placeholder="Total Pasivos"
                    formControlName="totalLiabilities"
                    required
                  />
                  <div
                    *ngIf="
                      this.ThirdFormGroup.controls['totalLiabilities'].invalid
                    "
                    style="display: block"
                    class="invalid-feedback"
                  >
                    Porfavor ingrese un Total Pasivos.
                  </div>
                </div>
              </div>
            </form>
            <div>
              <button
                class="btn btn-outline-secondary me-1"
                mat-button
                matStepperPrevious
              >
                Anterior
              </button>
              <button
                mat-button
                matStepperNext
                class="btn btn-success"
                (click)="saveUser()"
              >
                Guardar datos
              </button>
            </div>
          </mat-step>
        </mat-stepper>
      </div>
    </div>
  </div>
</div>
<!-- AddModal -->
<div
  bsModal
  #loadingCreateModal="bs-modal"
  class="modal fade"
  id="loadingCreateModal"
  tabindex="-1"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered modal-sm">
    <div class="modal-content">
      <div class="modal-body px-4 py-5 text-center">
        <div class="avatar-sm mb-4 mx-auto">
          <div
            class="avatar-title bg-primary text-primary bg-opacity-10 font-size-20 rounded-3"
          >
            <i class="mdi mdi-credit-card-sync"></i>
          </div>
        </div>
        <p class="text-muted font-size-16 mb-4">
          Estamos creando el codeudor..
        </p>
      </div>
    </div>
  </div>
</div>
<!-- End AddModal -->
